export function InfostatDataWarning() {
  return (
    <div className="infostat-data-warning">
      <h2>🦉 INFOSTAT-MÅTT 🦉</h2>
    </div>
  );
}
